(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avalyn-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  function crInitSection(section) {
    if (section.dataset.crInit === 'true') return;
    section.dataset.crInit = 'true';

    var track = section.querySelector('.cr-cards-track');
    var outer = section.querySelector('.cr-cards-outer');
    var prevBtn = section.querySelector('.cr-nav-btn.prev');
    var nextBtn = section.querySelector('.cr-nav-btn.next');

    if (!track || !outer || !prevBtn || !nextBtn) return;

    var currentIndex = 0;

    function getGap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    function getCardWidth() {
      var card = track.querySelector('.cr-card');
      if (!card) return 326;
      return card.offsetWidth + getGap();
    }

    function getMaxIndex() {
      var cards = track.querySelectorAll('.cr-card');
      var visibleCount = Math.floor(outer.offsetWidth / getCardWidth());
      return Math.max(0, cards.length - visibleCount);
    }

    function scrollTo(index) {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      track.style.transform = 'translateX(-' + (currentIndex * getCardWidth()) + 'px)';
    }

    prevBtn.addEventListener('click', function() {
      scrollTo(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function() {
      if (currentIndex >= getMaxIndex()) {
        scrollTo(0);
      } else {
        scrollTo(currentIndex + 1);
      }
    });

    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        scrollTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });

    window.addEventListener('resize', function() {
      scrollTo(currentIndex);
    });
  }

  function crInitAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.cr-section').forEach(crInitSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { crInitAll(); });
  } else {
    crInitAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    crInitAll(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avalyn-testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  function ctInitSection(section) {
    if (section.dataset.ctInit === 'true') return;
    section.dataset.ctInit = 'true';

    var carousel = section.querySelector('.custom-testimonials-carousel');
    var track = section.querySelector('.custom-testimonials-track');
    var prevBtn = section.querySelector('.custom-testimonials-nav-btn.prev');
    var nextBtn = section.querySelector('.custom-testimonials-nav-btn.next');
    var dotsContainer = section.querySelector('.custom-testimonials-dots');

    if (!track || !carousel || !prevBtn || !nextBtn) return;

    var originalCards = Array.prototype.slice.call(track.querySelectorAll('.custom-testimonial-card'));
    var total = originalCards.length;

    if (total === 0) return;

    // Clone cards before and after for infinite effect
    originalCards.forEach(function(card) {
      track.appendChild(card.cloneNode(true));
    });
    originalCards.slice().reverse().forEach(function(card) {
      track.insertBefore(card.cloneNode(true), track.firstChild);
    });

    var currentIndex = total;

    // Build dots
    if (dotsContainer) {
      originalCards.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'custom-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        dot.addEventListener('click', function() { goTo(total + i); });
        dotsContainer.appendChild(dot);
      });
    }

    function getCardWidth() {
      var card = track.querySelector('.custom-testimonial-card');
      return card ? card.offsetWidth + 20 : 320;
    }

    function getOffset() {
      var cardWidth = getCardWidth();
      return (carousel.offsetWidth - (cardWidth - 20)) / 2;
    }

    function goTo(index, animate) {
      if (animate === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.35s ease';
      }
      currentIndex = index;
      var offset = getOffset();
      track.style.transform = 'translateX(' + (offset - currentIndex * getCardWidth()) + 'px)';

      var realIndex = ((currentIndex - total) % total + total) % total;
      if (dotsContainer) {
        dotsContainer.querySelectorAll('.custom-dot').forEach(function(dot, i) {
          dot.classList.toggle('active', i === realIndex);
        });
      }
    }

    track.addEventListener('transitionend', function() {
      if (currentIndex <= total - 1) {
        goTo(currentIndex + total, false);
      } else if (currentIndex >= total * 2) {
        goTo(currentIndex - total, false);
      }
    });

    prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
    }, { passive: true });

    goTo(currentIndex, false);
    window.addEventListener('resize', function() { goTo(currentIndex, false); });
  }

  function ctInitAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.custom-testimonials').forEach(ctInitSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { ctInitAll(); });
  } else {
    ctInitAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    ctInitAll(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
